import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import oneID from './one-id/oneID'
import staticModule from './static/index'
import auth from './auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    oneID,
    staticModule,
    auth,
  },
  strict: process.env.DEV,
})
